import { z } from "zod";
export const PRODUCT_TYPES = ["web", "app", "game", "simulation", "server"];
export const productTypeSchema = z.enum(PRODUCT_TYPES);
export const PRODUCT_TYPE_POLICIES = {
    web: { defaultTickRateHz: 5, minTickRateHz: 1, maxTickRateHz: 10 },
    app: { defaultTickRateHz: 10, minTickRateHz: 1, maxTickRateHz: 30 },
    game: { defaultTickRateHz: 30, minTickRateHz: 1, maxTickRateHz: 120 },
    simulation: { defaultTickRateHz: 30, minTickRateHz: 1, maxTickRateHz: 60 },
    server: { defaultTickRateHz: 10, minTickRateHz: 1, maxTickRateHz: 60 },
};
export const tickRateHzSchema = z
    .number()
    .int()
    .min(1)
    .max(PRODUCT_TYPE_POLICIES.game.maxTickRateHz);
export const LEGACY_PRODUCT_TYPE = "app";
export const LEGACY_TICK_RATE_HZ = PRODUCT_TYPE_POLICIES[LEGACY_PRODUCT_TYPE].defaultTickRateHz;
//# sourceMappingURL=product.js.map